import React, { PropsWithChildren } from "react";
import Grid from "@material-ui/core/Grid";
import styled from "@emotion/styled";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

const Control = styled.div`
  display: block;
  text-align: center;
`;

export const ProductsTableControl = withShowIf((props: PropsWithChildren<any>) => (
  <Grid item={true} xs={6} sm={6} md={6} lg={6}>
    <Control>{props.children}</Control>
  </Grid>
));
